import { localeIgnoreCaseEquals } from './String';

export function getQueryStringParameter(paramName: string, caseSensitive = false) {
  const urlParams = new URLSearchParams(window.location.search || '');

  if (caseSensitive) {
    return urlParams.get(paramName);
  }

  for (const [key, value] of urlParams.entries()) {
    if (localeIgnoreCaseEquals(key, paramName)) {
      return value;
    }
  }

  return null;
}
